import { createSelector } from 'reselect';

import { getProps } from 'utils/selectors';

const getState = state => state.auditStatistics.oldReducer;
const getCount = createSelector(getState, ({ count }) => count);
const getAvgTime = createSelector(getState, ({ avgTime }) => avgTime);
const getAudits = createSelector(getState, ({ audits }) => audits);
const getAllData = createSelector(getState, ({ data }) => data.all);

export const getAuditStatisticsLinks = createSelector(getAllData, ({ links }) => links);
export const getAuditStatisticsResponses = createSelector(getAllData, ({ items }) => items);
export const getAuditStatisticsApiError = createSelector(getAllData, ({ apiError }) => apiError);
export const getAuditStatisticsIsFetching = createSelector(getAllData, ({ isFetching }) => isFetching);

export const getAuditStatisticsFilters = createSelector(getState, ({ filters }) => filters);

export const getPeriod = createSelector(getState, ({ period }) => period);
export const getAuditStatisticsCountValue = createSelector(getCount, ({ value }) => value);
export const getAuditStatisticsAvgTimeValue = createSelector(getAvgTime, ({ value }) => value ?? 0);

export const getAuditStatisticsAuditsItems = createSelector(getAudits, ({ items }) => items);
export const getAuditStatisticsAuditsLinks = createSelector(getAudits, ({ links }) => links);
export const getAuditStatisticsAuditsApiError = createSelector(getAudits, ({ apiError }) => apiError);
export const getAuditStatisticsAuditsIsFetching = createSelector(getAudits, ({ isFetching }) => isFetching);

export const getAuditStatisticsIsLoading = createSelector(
  getAuditStatisticsIsFetching,
  getProps,
  (loading, questionId) => loading?.[questionId]
);

export const getAuditStatisticsError = createSelector(
  getAuditStatisticsApiError,
  getProps,
  (errors, questionId) => errors?.[questionId]
);
